var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.125V6.25M3.125 12.5H6.25M5.87091 5.87088L8.08061 8.08058M5.87088 19.1291L8.08058 16.9194M21.875 12.5005H18.75M19.1292 5.87124L16.9195 8.08095M12.4998 21.8752V18.7502M19.1291 19.1294L16.9194 16.9197",
    stroke: "#B2B2B2",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputLoadingIcon);
export default __webpack_public_path__ + "static/media/input-loading-icon.6fe2ee70d6f0a08092775db5b4fa2d1b.svg";
export { ForwardRef as ReactComponent };